export const SET_TIMERS = 'SET_TIMERS';
export const SET_TIMER_LIST = 'SET_TIMER_LIST';
export const SET_SELECTED_TIMER = 'SET_SELECTED_TIMER';

export function setTimers(timers) {
  return {
    type: SET_TIMERS,
    payload: timers,
  };
}

export function setTimerList(list) {
  return {
    type: SET_TIMER_LIST,
    payload: list,
  };
}

export function setSelectedTimer(timer) {
  return {
    type: SET_SELECTED_TIMER,
    payload: timer,
  };
}



/** WEBPACK FOOTER **
 ** ./src/redux/timer/actions.js
 **/